import { useQuery } from '@apollo/client'
import { useMemo } from 'react'
import {
  DEPARTAMENTOS_CARGOS_USUARIOS_QUERY,
  DEPARTAMENTOS_COMUNICADOS_QUERY
} from '../data/departamentos'
import {
  DepartamentosCargosUsuariosQuery,
  DepartamentosComunicadosQuery
} from '@/core/types/graphql'
import { OptionSelect } from '../utils/types'

export interface DepartamentoOption extends OptionSelect {
  sigla: string
}

export const useDepartamentosCargosUsuarios = () => {
  const { data: { departamentosCargosUsuarios = [] } = {}, loading } =
    useQuery<DepartamentosCargosUsuariosQuery>(
      DEPARTAMENTOS_CARGOS_USUARIOS_QUERY
    )

  const departamentosOptions = useMemo(
    () =>
      departamentosCargosUsuarios?.map(it => ({
        label:
          it?.sigla && it.sigla.length > 0
            ? `[${it?.sigla}] ${it?.nome}`
            : it?.nome,
        value: it?.id,
        sigla: it?.sigla
      })) as DepartamentoOption[],
    [departamentosCargosUsuarios]
  )

  const departamentos = useMemo(
    () => departamentosCargosUsuarios,
    [departamentosCargosUsuarios]
  )

  return {
    departamentos,
    departamentosOptions,
    hasDepartamentos: (departamentos ?? []).length > 0,
    loading
  }
}

export const useDepartamentosComunicados = () => {
  const { data: { departamentosComunicados = [] } = {}, loading } =
    useQuery<DepartamentosComunicadosQuery>(DEPARTAMENTOS_COMUNICADOS_QUERY)

  const departamentosOptions = useMemo(
    () =>
      departamentosComunicados?.map(it => ({
        label: `[${it?.sigla}] ${it?.nome}`,
        value: it?.id,
        sigla: it?.sigla
      })) as DepartamentoOption[],
    [departamentosComunicados]
  )

  return {
    departamentos: departamentosComunicados,
    departamentosOptions,
    loading
  }
}
